//#region src/translate/hashText.ts
var e = (e) => {
	let t = 5381;
	for (let n = 0; n < e.length; n++) t = (t << 5) + t + e.charCodeAt(n) | 0;
	return `${e.length}:${(t >>> 0).toString(36)}`;
};
//#endregion
export { e as hashText };
